<res-base-modal [modalTitle]="modalTitle" [modalClass]="modalClass" [modalAutomationId]="modalAutomationId"
    (primaryButtonActionEmt)="ok()" (closeButtonActionEmt)="closeModal()" [modalHelpIndex]="modalHelpIndex"
    [isPrimaryBtnEnabled]="okEnabled() && !isSaveDisabled" [secondaryButtonLabel]="'Cancel'" [primaryButtonLabel]="'OK'"
    [resizeHorizontal]="true" [resizeHorizontalMin]="400" [resizeVertical]="true" [resizeVerticalMin]="400"
    [maximizable]="true" [(isBusy)]="isBusy" [(isBusyMessage)]="isBusyMessage">

    <res-left-right-selection-box [useDragAndDrop]="false" [automationId]="modalAutomationId" [itemsLeft]="itemsLeft"
        [itemsRight]="itemsRight" [leftListTitle]="leftListTitle" [leftListGridContext]="leftListGridContext"
        [rightListGridContext]="rightListGridContext" [rightListTitle]="rightListTitle"
        [leftListTemplate]="leftListGridTemplate" [rightListTemplate]="rightListGridTemplate" [rightListHeight]="50"
        [rightListSelection]="rowSelection" [leftGridRowClassRules]="'true'" [rowClassRules]="'true'"
        [leftListColumns]="leftListColumns"
        [rightListColumns]="rightListColumns" (customMoveItems)="copyOrRemoveItems($event)"
        (customItemSelection)="rightListOnSelectionChanged($event)"
        [leftListSize]="modalData.isMembershipModalOpenByAction === 'addToRemoveFromProjects' ? 45 : 50">
    </res-left-right-selection-box>

    <ng-template #leftListGridTemplate>
        <res-filter [placeholder]="filterPlaceholder" [maxChars]=32 [callback]="filterDataLeft.bind(this)"
            [filterInputAutoId]="modalAutomationId + '-left'" [clearButtonDataAutoId]="modalAutomationId + '-left'">
        </res-filter>
    </ng-template>

    <ng-template #rightListGridTemplate>
        <res-filter [placeholder]="filterPlaceholder" [maxChars]=32 [callback]="filterDataRight.bind(this)"
            [filterInputAutoId]="modalAutomationId + '-right'" [clearButtonDataAutoId]="modalAutomationId + '-right'">
        </res-filter>
    </ng-template>

</res-base-modal>